import Carousel from 'nuka-carousel';
import styled, { css } from 'styled-components';
import { media, mixins } from '../css';

export const StyledCarousel = styled(Carousel)`
  ${props =>
    props.backgroundImage &&
    css`
      background-image: ${`url(${props.backgroundImage})`};
    `};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: ${props => props.backgroundColor};

  overflow: hidden;
  && {
    .slider-control-bottomcenter {
      ${props => (!props.dotsUnder ? 'bottom: 11% !important;' : null)};

      ${props =>
        props.dotsUnder &&
        css`
          position: static !important;
          transform: translateX(0) !important;
        `};
      width: 100%;
      text-align: center;
    }
  }
`;

export const StyledCarouselButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: ${mixins.pxToRem(10)};
  outline: 0;
`;

export const StyledPagingArrow = styled.button`
  ${media.lessThan('lg')`
    display: none;
  `};
  border: 0;
  background: transparent;
  cursor: pointer;
  outline: 0;
  ${props => (props.direction === 'left' ? `left: ${mixins.pxToRem(80)}` : `right: ${mixins.pxToRem(80)}`)};

  ${media.lessThan('xl')`
    ${props => (props.direction === 'left' ? `left: ${mixins.pxToRem(45)}` : `right: ${mixins.pxToRem(45)}`)};
  `};
  position: relative;
`;

export const StyledCarouselList = styled.ul`
  position: relative;
  margin: 0;
  height: auto;
  padding: 0;
`;
